import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedTotalMembers($partnerId: ID!) {
    community(id: $partnerId) {
      id
      stats {
        totalMembers
      }
    }
  }
`);
